import React, { ReactNode } from 'react';

import { Box, Paper, Typography } from '@material-ui/core';

interface Props {
  title: string;
  description: string;
  secondaryButton?: ReactNode;
  primaryButton: ReactNode;
}

const PaperAction: React.FC<Props> = ({ title, description, secondaryButton, primaryButton }) => {
  return (
    <Paper>
      <Box p={4}>
        <Box mb={1}>
          <Typography variant="h6">{title}</Typography>
        </Box>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Box>

      <Box p={2} pt={0} display="flex" justifyContent="right">
        {secondaryButton !== undefined && secondaryButton}
        {primaryButton}
      </Box>
    </Paper>
  );
};

export default PaperAction;
